import { api } from '@/services/api/api';
import fileDownload from 'js-file-download';
import {
  IDriverWithSubmitRequest,
  IDriverWithSubmitResponse,
} from '@/services/api/specialPriceTable/message/DriverWithSubmitRequest';
import {
  IDriverWithDraftRequest,
  IDriverWithDraftResponse,
} from '@/services/api/specialPriceTable/message/DriverWithDraftRequest';
import {
  IGetDriverWithDraftRequest,
  IGetDriverWithDraftResponse,
} from '@/services/api/specialPriceTable/message/GetDriverWithDraftRequest';
import {
  IUseDriverWithDraftRequest,
  IUseDriverWithDraftResponse,
} from '@/services/api/specialPriceTable/message/UseDriverWithDraftRequest';
import {
  IDeleteDriverWithDraftRequest,
  IDeleteDriverWithDraftResponse,
} from '@/services/api/specialPriceTable/message/DeleteDriverWithDraft';
import {
  IMailOutSubmitRequest,
  IMailOutSubmitResponse,
} from '@/services/api/specialPriceTable/message/MailOutSubmitRequest';
import {
  IMailOutDraftRequest,
  IMailOutDraftResponse,
} from '@/services/api/specialPriceTable/message/MailOutDraftRequest';
import {
  IGetMailOutDraftRequest,
  IGetMailOutDraftResponse,
} from '@/services/api/specialPriceTable/message/GetMailOutDraftRequest';
import {
  IUseMailOutDraftRequest,
  IUseMailOutDraftResponse,
} from '@/services/api/specialPriceTable/message/UseMailOutDraftRequest';
import { IPreviewTableRequest, IPreviewTableResponse } from '@/services/api/specialPriceTable/message/PreviewTable';
import {
  SpecialPriceApprovalRequest,
  SpecialPriceApprovalResponse,
} from '@/services/api/specialPriceTable/message/SpecialPriceApprovalRequest';
import {
  SearchSpecialPrickHeaderTableRequest,
  SearchSpecialPrickHeaderTableResponse,
} from '@/services/api/specialPriceTable/message/SearchSpecialPrickHeaderTableRequest';
import {
  BaseSpecialPrickIdGetCustomerRequest,
  BaseSpecialPrickIdGetCustomerResponse,
} from '@/services/api/specialPriceTable/message/BaseSpecialPrickIdGetCustomerRequest';
import {
  BaseSpecialPrickIdGetMaterialRequest,
  BaseSpecialPrickIdGetMaterialResponse,
} from '@/services/api/specialPriceTable/message/BaseSpecialPrickIdGetMaterialRequest';
import {
  PreviewSpecialsRequest,
  PreviewSpecialsResponse,
} from '@/services/api/specialPriceTable/message/PreviewSpecialsRequest';
import {
  PreviewSpecialsMailRequest,
  PreviewSpecialsMailResponse,
} from '@/services/api/specialPriceTable/message/PreviewSpecialsMailRequest';
import {
  LabelPrinterCustomerRequest,
  LabelPrinterCustomerResponse,
} from '@/services/api/specialPriceTable/message/LabelPrinterCustomerRequest';
import {
  GetSpecialPriceSalesInitializationInformationRequest, GetSpecialPriceSalesInitializationInformationResponse,
} from '@/services/api/specialPriceTable/message/GetSpecialPriceSalesInitializationInformationRequest';
import {
  ExportSaleTableSalesApplicationStatusRequest,
} from '@/services/api/specialPriceTable/message/ExportSaleTableSalesApplicationStatusRequest';
import {
  HasDiscountTableDownloadPermissionRequest,
  HasDiscountTableDownloadPermissionResponse,
} from './message/HasDiscountTableDownloadPermissionRequest';
import {
  DownloadSpecialPriceTableLabWordRequest,
} from '@/services/api/specialPriceTable/message/DownloadSpecialPriceTableLabWordRequest';

/**
 *  司机带提交数据
 * @param params
 * @constructor
 */
export const DriverWithSubmitApi =
    async (params: IDriverWithSubmitRequest): Promise<IDriverWithSubmitResponse> => {
      return await api.post('/SpecialPriceTable/DriverWithSubmit', params);
    };
/**
 * 司机带草稿保存
 * @param params
 * @constructor
 */
export const DriverWithDraftApi =
    async (params: IDriverWithDraftRequest): Promise<IDriverWithDraftResponse> => {
      return await api.post('/SpecialPriceTable/DriverWithDraft', params);
    };

/**
 * 司机带得到草稿列表
 * @param params
 * @constructor
 */
export const GetDriverWithDraftApi =
    async (params: IGetDriverWithDraftRequest): Promise<IGetDriverWithDraftResponse> => {
      return await api.get('/SpecialPriceTable/GetDriverWithDraft', { params });
    };

/**
 * 使用司机带草稿
 * @param params
 * @constructor
 */
export const UseDriverWithDraftApi =
    async (params: IUseDriverWithDraftRequest): Promise<IUseDriverWithDraftResponse> => {
      return await api.get('/SpecialPriceTable/UseDriverWithDraft', { params });
    };

/**
 * 删除司机带草稿
 * @param params
 * @constructor
 */
export const DeleteDriverWithDraftApi =
    async (params: IDeleteDriverWithDraftRequest): Promise<IDeleteDriverWithDraftResponse> => {
      return await api.post('/SpecialPriceTable/DeleteDriverWithDraft', params);
    };

// 以下为邮寄出去api

/**
 * 邮寄出去提交数据
 * @param params
 * @constructor
 */
export const MailOutSubmitApi =
    async (params: IMailOutSubmitRequest): Promise<IMailOutSubmitResponse> => {
      return await api.post('/SpecialPriceTable/MailOutSubmit', params);
    };

/**
 * 邮寄出去草稿保存
 * @param params
 * @constructor
 */
export const MailOutDraftApi =
    async (params: IMailOutDraftRequest): Promise<IMailOutDraftResponse> => {
      return await api.post('/SpecialPriceTable/MailOutDraft', params);
    };

/**
 * 得到邮寄出去草稿列表
 * @param params
 * @constructor
 */
export const GetMailOutDraftApi =
    async (params: IGetMailOutDraftRequest): Promise<IGetMailOutDraftResponse> => {
      return await api.get('/SpecialPriceTable/GetMailOutDraft', { params });
    };

/**
 *  使用邮寄出去草稿
 * @param params
 * @constructor
 */
export const UseMailOutDraftApi =
    async (params: IUseMailOutDraftRequest): Promise<IUseMailOutDraftResponse> => {
      return await api.get('/SpecialPriceTable/UseMailOutDraft', { params });
    };

/**
 * 预览价钱表List
 * @param params
 * @constructor
 */
export const PreviewTableApi =
    async (params: IPreviewTableRequest): Promise<IPreviewTableResponse> => {
      return await api.post('/SpecialPriceTable/PreviewTable', params);
    };

/**
 * 审批特价表
 * @param params
 * @constructor
 */
export const SpecialPriceApprovalApi =
    async (params: SpecialPriceApprovalRequest): Promise<SpecialPriceApprovalResponse> => {
      return await api.post('/SpecialPriceTable/SpecialPriceApproval', params);
    };

/**
 * 根据头部搜索展示header提交的数据
 * @param params
 * @constructor
 */
export const SearchSpecialPrickHeaderTableApi =
    async (params: SearchSpecialPrickHeaderTableRequest): Promise<SearchSpecialPrickHeaderTableResponse> => {
      return await api.post('/SpecialPriceTable/SearchSpecialPrickHeaderTable', params);
    };

/**
 * 基于 SpecialPrickId Load 客户信息Item
 * @param params
 * @constructor
 */
export const BaseSpecialPrickIdGetCustomerApi =
    async (params: BaseSpecialPrickIdGetCustomerRequest): Promise<BaseSpecialPrickIdGetCustomerResponse> => {
      return await api.post('/SpecialPriceTable/BaseSpecialPrickIdGetCustomer', params);
    };

/**
 * 基于 SpecialPrickId Load 物料信息Item
 * @param params
 * @constructor
 */
export const BaseSpecialPrickIdGetMaterialApi =
    async (params: BaseSpecialPrickIdGetMaterialRequest): Promise<BaseSpecialPrickIdGetMaterialResponse> => {
      return await api.post('/SpecialPriceTable/BaseSpecialPrickIdGetMaterial', params);
    };

/**
 * 预览司机带特价表 , 一个客户就是一张特价表 , 一页 22 条数据 , 11 条放一个 List
 * @param params
 * @constructor
 */
export const PreviewSpecialsApi =
    async (params: PreviewSpecialsRequest): Promise<PreviewSpecialsResponse> => {
      return await api.post('SpecialPriceTable/PreviewSpecials', params);
    };

/**
 * 预览 邮寄特价表 , 只需要返回特价数据就行了 , 返回22条价钱数据
 * @param params
 * @constructor
 */
export const PreviewSpecialsMailApi =
    async (params: PreviewSpecialsMailRequest): Promise<PreviewSpecialsMailResponse> => {
      return await api.post('SpecialPriceTable/PreviewSpecialsMail', params);
    };

/**
 * 客户邮寄标签的贴纸
 * @param params
 * @constructor
 */
export const LabelPrinterCustomerApi =
    async (params: LabelPrinterCustomerRequest): Promise<LabelPrinterCustomerResponse> => {
      return await api.post('SpecialPriceTable/LabelPrinterCustomer', params);
    };

/**
 * 得到初始化的Sales相关的信息
 * @param params
 * @constructor
 */
export const GetSpecialPriceSalesInitializationInformationApi =
    async (params: GetSpecialPriceSalesInitializationInformationRequest): Promise<GetSpecialPriceSalesInitializationInformationResponse> => {
      return await api.post('SpecialPriceTable/GetSpecialPriceSalesInitializationInformation', params);
    };

export const ExportSaleTableSalesApplicationStatus = (params: ExportSaleTableSalesApplicationStatusRequest) => {
  api({
    url: 'SpecialPriceTable/ExportSaleTableSalesApplicationStatus',
    method: 'POST',
    data: params,
    responseType: 'blob',
  }).then((res) => {
    const fileName = res.headers['file-download-name'];
    fileDownload(res.data, fileName);
  });
};

export const DownloadSpecialPriceTableLabWord = (params : DownloadSpecialPriceTableLabWordRequest) => {
  api({
    url: 'SpecialPriceTable/DownloadSpecialPriceTableLabWord',
    method: 'POST',
    data: params,
    responseType: 'blob',
  }).then((res) => {
    const fileName = res.headers['file-download-name'];
    fileDownload(res.data, fileName);
  });
};

/**
 * 判断是否有导出特价表的权限
 * @param params
 * @constructor
 */
export const HasDiscountTableDownloadPermissionApi =
    async (params: HasDiscountTableDownloadPermissionRequest): Promise<HasDiscountTableDownloadPermissionResponse> => {
      return await api.post('/SpecialPriceTable/HasDiscountTableDownloadPermission', params);
    };
